import React from 'react';
import AIStreamingQuery from '../components/AIStreamingQuery';

const AIQueryViewer = ({ currentUser, fetchWithAuth }) => {
  return (
    <AIStreamingQuery fetchWithAuth={fetchWithAuth} />
  );
};

export default AIQueryViewer;